module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("录音设备挑选")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.\t常见的录音设备有哪些 ?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "744px",
      "height": "243px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_12.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2. 录音设备会让我们的声音变好听吗？不购买设备可以吗？")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3. 如何挑选声卡？")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "625px",
      "height": "220px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_13.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4. 如何挑选麦克风和耳机声卡？")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "625px",
      "height": "220px"
    },
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/img_14.jpeg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5. 去哪里购买这些设备呢？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("如果家附近有实体的音频售卖店、录音棚那就最好了，大家可以去试一下然后选择最适合自己的，网上购买的话选择正规的商城就可以了，最重要的是一定要找售后给你做好调试。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("6. 有简易录音设备推荐吗？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("推荐录音笔，录音笔存储容量大，大多数录音笔可以盲操作开始录音。高端一点的录音笔还有降噪技术，而且Mic全方向性好。手机也有降噪技术，但是这个会导致Mic的单向性很强，不利于录音这种应用。录音笔支持文件的导出和编辑，也就是后续比较方便，利于直接导入电脑，归档和剪辑音频，和删除一些不重要的内容。")]), _vm._v(" "), _c('table', {
    staticClass: "anchor"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_1.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("SONYPCM_D100")]), _vm._v(" "), _c('td', [_vm._v("说话时摩擦手指声音都可以完整收录，立体声音频效果非常棒。")]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_2.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Zoom H1")]), _vm._v(" "), _c('td', [_vm._v("声音的采集可以自动调节，人声还原效果好。")]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_3.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("飞利浦VTR5100")]), _vm._v(" "), _c('td', [_vm._v("性价比高，声音清晰，外观小巧。")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_4.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("iRig Voice")]), _vm._v(" "), _c('td', [_vm._v("带监听功能，iOS和Android都能用。")]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_5.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Tascam")]), _vm._v(" "), _c('td', [_vm._v("iOS专用，音质较好，家用方便。")]), _vm._v(" "), _vm._m(9)])])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("7. 有专业录音设备推荐吗？")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('table', {
    staticClass: "anchor"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("声卡")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_6.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("艾肯外置声卡 ICON upodnano")]), _vm._v(" "), _c('td', [_vm._v("录制稳定，底噪好控制。")]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("话筒")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_7.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("ISK BM-800")]), _vm._v(" "), _c('td', [_vm._v("声音醇厚，效果好。")]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("耳机")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_8.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("耳机AKG/爱科技 k99")]), _vm._v(" "), _c('td', [_vm._v("阻抗效果比较好，各频段算均衡，音质不错。")]), _vm._v(" "), _vm._m(14)])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('table', {
    staticClass: "anchor"
  }, [_vm._m(16), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("声卡1")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_9.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("艾肯外置声卡 ICON upodnano")]), _vm._v(" "), _c('td', [_vm._v("录制稳定，底噪好控制。")]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("声卡2")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_10.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("雅马哈AG06（雅马哈声卡只支持一个电容麦）")]), _vm._v(" "), _c('td', [_vm._v("有自带压限，调音功能强大。")]), _vm._v(" "), _vm._m(18)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("话筒")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_11.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("舒尔（Shure）SM58S")]), _vm._v(" "), _c('td', [_vm._v("可有效抑制风噪和呼吸爆音，增强主声源，最大限度地抑制背景噪音。")]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("耳机")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_12.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("耳机AKG/爱科技 k99")]), _vm._v(" "), _c('td', [_vm._v("阻抗效果比较好，各频段算均衡，音质不错。")]), _vm._v(" "), _vm._m(20)])])]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('table', {
    staticClass: "anchor"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("声卡1")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_13.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("艾肯外置声卡 ICON upodnano")]), _vm._v(" "), _c('td', [_vm._v("录制稳定，底噪好控制。")]), _vm._v(" "), _vm._m(23)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("话筒1")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_14.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("艾肯电容麦克风 ICON M3")]), _vm._v(" "), _c('td', [_vm._v("清澈细致的录音效果，极低低噪，高输出电平，无交越失真。")]), _vm._v(" "), _vm._m(24)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("话筒2")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_15.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("EDMiCN原飞乐ED330")]), _vm._v(" "), _c('td', [_vm._v("对声场的感应达到极高的灵敏，为你捕捉声音最最细腻的部分。")]), _vm._v(" "), _vm._m(25)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("耳机")]), _vm._v(" "), _c('td', [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "anchorHelpCenter/equipment_16.png")
    }
  })]), _vm._v(" "), _c('td', [_vm._v("耳机AKG/爱科技 k99")]), _vm._v(" "), _c('td', [_vm._v("阻抗效果比较好，各频段算均衡，音质不错。")]), _vm._v(" "), _vm._m(26)])])]), _vm._v(" "), _vm._m(27)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("常见的录音设备有：声卡、麦克风、耳机、调音台和录音笔。\n        "), _c('br'), _vm._v("如果一般是在家里或者其他安静固定的环境录音的话，那么建议大家可以购买声卡、麦克风和耳机。调音台的最大优点是多线路管理，一般我们家用是无需购买的。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("录音设备会让我们的声音更好听，但是这个好听的意思是：更清晰、更还原你的音色。我们可以通过调整高中低频小范围的改善音色，但如果想拥有磁性的声音还是需要本身的声音练习哦！\n        "), _c('br'), _vm._v("目前，我们喜马拉雅的录音可以通过手机客户端和网页在线直接进行录音上传，也可以在电脑上下载录音软件进行录制。由于有声作品录制对音质要求较高，建议您购买录音设备。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("声卡简单来说，有输出和输入两个作用。把麦克风、乐器等输入到电脑里转换成电子信号，再通过音响、耳机等输出成音频信号，每一台电脑都是有声卡的，但是多为集成声卡，无法满足录制高质量音频的需要，而我们需要购买的则为独立声卡。\n        "), _c('br'), _vm._v("独立声卡分为内置声卡和外置声卡两种。内置声卡只适用于有PCI卡槽的台式电脑，调试效果需要使用机架，使用起来相对来说比较困难。外置声卡又叫USB声卡，笔记本、台式、一体机电脑都可以使用，价格比内置声卡稍贵一些，部分外置声卡操作起来比较傻瓜。所以呢，如果我们是使用的笔记本或者一体机，那么就只能购买外置声卡了哦。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("麦克风一般分为电容麦和动圈麦。动圈麦的声音一般来说比较闷，而电容麦则更饱满，这里要提醒大家，电容麦是需要供电的，一般为48V，如果购买电容麦的话，一定要查看自己的声卡有没有供电功能，像艾肯这样的牌子每一款都有供电功能，但像客所思这样的国产品牌则每个型号都不一样，如果确定你的声卡没有供电的话，需要另外购买供电电源才能使用哦。\n        "), _c('br'), _vm._v("而电容麦也分为心形指向和全指向，全指向就是麦克风的四周收音效果都是一致的，心形指向的电容麦呢，就是麦克风的正面收音极好，侧面衰弱，背面几乎无法收音。如果家里隔音效果不好的话可以购买动圈或者是心形指向的电容麦。\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("设备样式")]), _vm._v(" "), _c('th', [_vm._v("设备型号")]), _vm._v(" "), _c('th', [_vm._v("优点")]), _vm._v(" "), _c('th', [_vm._v("购买链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/988958.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/1124743880.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/1404802.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/11260904044.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/1323159.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("简易的设备满足不了大部分专业主播的需求，使用专业的录音设备，使您的节目清晰，能愉悦粉丝的耳朵；如果您想录制专业的音频，想用更专业的设备，可以参考下面的推荐的设备搭配。\n        "), _c('br'), _c('strong', [_vm._v("推荐搭配一：")]), _vm._v(" "), _c('br'), _vm._v("适合刚入门及业余玩声音的朋友，这一套设备性价比高，免驱动，操作方便，但缺点是音色不够纯净。"), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/22899715/sound/18816278/",
      "target": "_blank"
    }
  }, [_vm._v("预估效果试听")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("设备样式")]), _vm._v(" "), _c('th', [_vm._v("设备型号")]), _vm._v(" "), _c('th', [_vm._v("优点")]), _vm._v(" "), _c('th', [_vm._v("购买链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/999545.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/4180819.html#crumb-wrap"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://item.jd.hk/1990482566.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('br'), _c('strong', [_vm._v("推荐搭配二：")]), _vm._v(" "), _c('br'), _vm._v("此套设备操作便利，音效好，如果强调内容为主的主播推荐使用此套设备，但缺点是不支持同时使用两个电容话筒。"), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1342948/sound/18795380/",
      "target": "_blank"
    }
  }, [_vm._v("预估效果试听")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("设备样式")]), _vm._v(" "), _c('th', [_vm._v("设备型号")]), _vm._v(" "), _c('th', [_vm._v("优点")]), _vm._v(" "), _c('th', [_vm._v("购买链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/999545.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/10164947538.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/10105139507.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://item.jd.hk/1990482566.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_c('br'), _c('strong', [_vm._v("推荐搭配三：")]), _vm._v(" "), _c('br'), _vm._v("此套装备适合专业人士使用，软件带有多种音响效果，音色纯净，音质好。"), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/3893464/sound/18743487/",
      "target": "_blank"
    }
  }, [_vm._v("预估效果试听")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("设备样式")]), _vm._v(" "), _c('th', [_vm._v("设备型号")]), _vm._v(" "), _c('th', [_vm._v("优点")]), _vm._v(" "), _c('th', [_vm._v("购买链接")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/999545.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://item.jd.com/1009220.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.vbmh9h&id=524522630128&cat_id=2&rn=7ce51cb45afc7875eecc824c84458039&user_id=2221721666&is_b=1"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://item.jd.hk/1990482566.html"
    }
  }, [_vm._v("购买参考链接")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("话筒架：按使用情况配置（立式及桌面固定式）防震架，防喷罩按实际情况购买最重要的是一定要找售后给你做好调试哦，切记切记！\n        "), _c('br'), _vm._v("更高配置如果以上设备还不满足您对于音质的追求，欢迎您到喜马拉雅声创空间的录音棚进行录制。想要更多地了解声创空间请"), _c('a', {
    attrs: {
      "href": "http://ximalayasckj.sxl.cn/",
      "target": "_blank"
    }
  }, [_vm._v("点击这里")]), _vm._v("。"), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/1084167/sound/18727157/",
      "target": "_blank"
    }
  }, [_vm._v("预估效果试听")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("录完了节目，后期制作当然也少不了。良好的后期处理，是提升您节目专业度的关键，会起到画龙点睛的效果。常用的音频处理软件有：Adobe Audition/Cooledit等。关于Au录音及简单后期制作的简易教程，"), _c('a', {
    attrs: {
      "href": "http://blog.ximalaya.com/adobe-audition/",
      "target": "_blank"
    }
  }, [_vm._v("请点击这里")]), _vm._v(" "), _c('br'), _vm._v("推荐耳机：喜马拉雅3D降噪耳机喜马拉雅把直播听成现场，"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://ximalayahaoshengyin.tmall.com/category-1309830001.htm?spm=a1z10.1-b-s.w5002-16689469995.6.19335493kpvNoL&search=y&catName=%B6%FA%BB%FA"
    }
  }, [_vm._v("点击购买")]), _vm._v("。\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c66c2308!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/PickEquipment.vue
// module id = 363
// module chunks = 0